import { render, staticRenderFns } from "./VideoDetailPage.vue?vue&type=template&id=75814f40&scoped=true"
import script from "./VideoDetailPage.vue?vue&type=script&lang=js"
export * from "./VideoDetailPage.vue?vue&type=script&lang=js"
import style0 from "./VideoDetailPage.vue?vue&type=style&index=0&id=75814f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75814f40",
  null
  
)

export default component.exports